import _ from 'underscore';
import 'edge/quoteandbind/common/models/Submission';
import Driver from 'edge/quoteandbind/pa/models/Driver';
import 'edge/quoteandbind/common/models/Person';
import Vehicle from 'edge/quoteandbind/pa/models/Vehicle';

var nextId = void 0;

var PACoverables = function PACoverables(data, submission) {
    if (data && _.isObject(data)) {
        this.drivers = _.map(data.drivers, function (d) {
            var driver = new Driver(d);
            driver.person = submission.findPerson(submission, d.person);
            return driver;
        }, this);

        this.vehicles = _.map(data.vehicles, function (v) {
            return new Vehicle(v);
        }, this);
    } else {
        this.drivers = [];
        this.vehicles = [];
    }
};

PACoverables.prototype.createDriver = function (person) {
    var driver = new Driver({
        person: person,
        dateOfBirth: person.dateOfBirth
    });
    driver.tempID = nextId();

    this.drivers.push(driver);
    return driver;
};

PACoverables.prototype.removeDriver = function (driver) {
    var idx = _.indexOf(this.drivers, driver);
    if (idx >= 0) {
        this.drivers.splice(idx, 1);
    }
};

PACoverables.prototype.createVehicle = function (person) {
    var v = new Vehicle({
        tempId: nextId()
    });
    if (person && person.primaryAddress) {
        v.licenseState = person.primaryAddress.state;
    }
    this.vehicles.push(v);
    return v;
};

PACoverables.prototype.removeVehicle = function (vehicle) {
    var idx = _.indexOf(this.vehicles, vehicle);
    if (idx >= 0) {
        this.vehicles.splice(idx, 1);
    }
};

PACoverables.prototype.getDriverForPerson = function (person) {
    var driver = _.findWhere(this.drivers, {
        person: person
    });

    if (driver.dateOfBirth !== person.dateOfBirth) {
        driver.dateOfBirth = person.dateOfBirth;
    }
    return driver;
};

var PASubmissionDataExtension = function PASubmissionDataExtension(submission) {
    nextId = submission.nextId;

    var paData = submission.lobData.personalAuto;
    if (paData) {
        this.preQualQuestionSets = paData.preQualQuestionSets || [];
        this.offerings = paData.offerings || [];
        this.coverables = new PACoverables(paData.coverables, submission);
    }
};

export default PASubmissionDataExtension;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/models/PASubmissionDataExtension.js
// module id = 1204
// module chunks = 0